import Alpine from 'alpinejs'

//import Glide from '@glidejs/glide';
import Glide, { Controls, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

//import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'
import Plyr from 'plyr';

//import Fuse from 'fuse.js';
import objectFitImages from 'object-fit-images';

//import 'page-accelerator/dist/page-accelerator.min.js';

// Initiate Alpine
window.Alpine = Alpine
Alpine.start()

try {
    window.$ = window.jQuery = require('jquery-slim');
    //Swiper = require('swiper/dist/js/swiper.min.js');
    window.Fuse = require('fuse.js');
    window.objectFitImages = objectFitImages;
} catch (e) {}

//mobile
$('.menu-btn').click(function(){
    $('.mobile-drawer').toggleClass('open');
});

//jumbonav code to show the menu
var menuVisible = false;
$('.primary-nav a').hover(function() {

    var link = $(this);

    if(menuVisible) {
        //console.log('another menu is visible');
        //another menu is visible
        //hide all jumbo menus
        $('.jumbo-menu').addClass('d-none');
        //remove hovered class from all of them
        $('.primary-nav a').removeClass('hovered');
        menuVisible = false;
    }

    var menuData = $(this).data('menu');
    //console.log(menuData);

    if(menuData != undefined) {
        $(this).addClass("hovered");
        var jumboMenu = $("[data-menu-for='"+ menuData +"']");

        //console.log(jumboMenu.length);

        if(jumboMenu.length > 0) {
            $(jumboMenu).removeClass('d-none');
            $(jumboMenu).addClass('animated fadeIn');
            menuVisible = true;

            $(jumboMenu).off().hover( function () {
                //on enter
            }, function () {
                //on remove
                $(link).removeClass("hovered");
                $(jumboMenu).addClass('fadeOut');
                setTimeout(() => {
                    $(jumboMenu).removeClass('animated fadeIn fadeOut');
                    $(jumboMenu).addClass('d-none');
                }, 500);
                menuVisible = false;
            });
        } else {
            // $(link).off().hover( function () {
            //     //on enter
            // }, function () {
                $(link).removeClass("hovered");
                $(jumboMenu).addClass('fadeOut');
                setTimeout(() => {
                    $(jumboMenu).removeClass('animated fadeIn fadeOut');
                    $(jumboMenu).addClass('d-none');
                }, 500);
                menuVisible = false;
            //});
        }
    }




});

//jumbonav functionality for hiding the menu
$('.quick-links-bar').off().hover( function () {
    //on enter
    menuVisible = false;
    $('.jumbo-menu').addClass('d-none');
    $('.primary-nav a').removeClass('hovered');
}, function () {
    //here we go
});

//for the news section on the homepage
$('.collapsible-container').each(function(){

    var container = this;
    var containerHeader = $(this).find('header');
    var containerContents = $(this).find('.container-contents');
    var toggleIcon = $(this).find('.icon-open-close');

    $(containerHeader).click(function() {
        $(containerContents).toggleClass('hide');
        $(toggleIcon).toggleClass('open');
    });

});

//homepage providers slider
$('.slider-sm-down').each(function(index) {

    //console.log(index);
    var breakpoint = 768;
    var mounted = false;

    var sliderContainer = $(this);
    var slider = $(this).find('.glide');

    var prevBtn = $(this).find('.prev');
    var nextBtn = $(this).find('.next');

    var glide = new Glide($(slider).get(0), {
      type: 'carousel',
      focusAt: 'center',
      perView: 1,
    });

    glide.on('run', function() {
        $('.index').text( glide.index + 1);
    });

    $(prevBtn).click(function() {
        if(mounted) {
            glide.go('<');
        }
    });

    $(nextBtn).click(function() {
        if(mounted) {
            glide.go('>');
        }
    });

    if( window.innerWidth < breakpoint ) {
        //mount it
        glide.mount();
        mounted = true;
    }

    window.onresize = () => {

        var windowWidth = window.innerWidth;
        if( (windowWidth < breakpoint) && (!mounted) ) {
            //mount it
            glide.mount();
            mounted = true;
        } else if( (windowWidth >= breakpoint) && (mounted) ) {
            //destroy it
            glide.destroy();
            mounted = false;
        }

    }
});

//testimonial slider
$('.testimonial-slider').each(function(index) {

    //console.log('hey');

    //console.log(index);
    var slider = $(this).find('.glide');

    var prevBtn = $(this).find('.prev');
    var nextBtn = $(this).find('.next');

    var glide = new Glide($(slider).get(0), {
      type: 'carousel',
      focusAt: 'center',
      perView: 1,
      autoplay: 4000
    });

    glide.on('run', function() {
        $('.index').text( glide.index + 1);
    });

    $(prevBtn).click(function() {
        glide.go('<');
    });

    $(nextBtn).click(function() {
        glide.go('>');
    });


    glide.mount();

});

$('.nav-tabs a.nav-link').click(function() {
    var tab = $(this).attr('aria-controls');

    $('.nav-tabs a.nav-link').removeClass('active');
    $(this).addClass('active');

    $('.tab-content .tab-pane').removeClass('show').removeClass('active');
    $('.tab-content').find('#'+tab).addClass('show').addClass('active');

});

window.onload = function () {
    if(window.location.hash) {
        var id = window.location.hash.substring(1);
        $('[href="' + window.location.hash + '"]').click();
        var link = document.getElementById(id);
        if( link ) {
            link.scrollIntoView();
        }

        if( document.getElementById('specialty-search') != null ) {
            document.getElementById('specialty-search').value = unescape(id);
            $('#specialty-search').change();
        }

    }
}

function openOverlay(options) {

    $('.overlay').show();
    $('.overlay').addClass('animated fadeInDown');
    //$('body').addClass('no-scroll');

    switch (options.type) {
        case 'image':
            var myImage = new Image();
            myImage.src = options.items[options.currentIndex].src;
            //document.body.appendChild(myImage);
            $('.overlay-container').html(myImage);
            break;
        case 'video':
            var videoEl = $('<div class="video-container"><div id="player" data-plyr-provider="'+ options.video.provider +'" data-plyr-embed-id="'+ options.video.id +'"></div></div>');
            $('.overlay-container').html(videoEl);
            const player = new Plyr(document.getElementById('player'));
            player.on('ready', event => {
                const instance = event.detail.plyr;
                player.play();
            });
            break;
        case 'search':
            $('.overlay-container').html( $('.form-holder').html() );
            $('.overlay-container .form-control').focus();
        default:

    }

}

function closeOverlay() {
    $('.overlay').addClass('fadeOutUp');
    //$('body').removeClass('no-scroll');
    $('.overlay-container').html('');
    setTimeout(() => {
        $('.overlay').removeClass('animated fadeInDown fadeOutUp');
        $('.overlay').hide();
    }, 500);
}

$('.overlay-close').click(function() {
    closeOverlay();
});

$('.file-photo').click(function() {

    var options = [];
    var gallery = $(this).data('gallery');
    var currentSrc = $(this).data('src');
    var galleryItems = [];

    options.type = 'image';

    $('[data-gallery="'+ gallery +'"]').each(function(index){
        var item = [];
        item.title = $(this).data('title');
        item.src = $(this).data('src');
        galleryItems.push(item);
        if(currentSrc == item.src) {
            options.currentIndex = index;
        }

    });

    options.items = galleryItems;
    openOverlay(options);

});

$('.file-video').click(function() {

    var options = [];
    var video = [];

    options.type = 'video';
    video.provider = $(this).data('plyr-provider');
    video.id = $(this).data('plyr-embed-id');
    options.video = video;

    openOverlay(options);

});


$('.toggle-hours-action').click(function() {

    var now_hours = $(this).parent().find('.now-hours');
    var hour_details = $(this).parent().find('.hours-details');
    var hour_toggle = $(this).find('.hour-toggle');


    $(now_hours).toggleClass('d-none');
    $(hour_details).toggleClass('d-none');
    $(hour_toggle).toggleClass('toggle-open');

});

//providers search
var results_visible = false;

$('#specialty-search').focus(function(){
    //console.log('we have focus');
    $(this).val('');
});

$('#specialty-search').change(function() {

    if(!results_visible) {
        $('.provider-results').show();
    }

    $('#doctor-search').val('');
    var specialtyId = $(this).val();
    if(specialtyId == '') {
        $('.provider').show();
    } else {
        //console.log(specialtyId);
        //console.log(
            var actual_id = $('#specialties option[value="'+ specialtyId +'"]').data('value');
        //);
        $('.provider').hide();
        $('.specialty-'+actual_id).show();
    }
});

$(function() {
    if( $('#specialty-search').val().length > 3 ) {
        $('#specialty-search').trigger('change');
    }
});

var people_json = $('#people-json').text();
if(people_json) {

    var people_json = JSON.parse( people_json );
    var options = {
      keys: ['id', 'name'],
      id: 'id',
      includeScore: true,
      threshold: 0.3 //make number larger to be more generous
    }
    var fuse = new Fuse(people_json, options);

    $('#doctor-search').keyup(function() {

        if(!results_visible) {
            $('.provider-results').show();
        }

        $('#specialty-search').val('');
        var search_string = $(this).val();

        if(search_string.length > 1) {
            var results = fuse.search(search_string);
            $('.provider').hide();
            for (var i = 0; i < results.length; i++) {
                console.log( results[i] );
                $('.person-'+results[i].item).show();
            }
        } else {
            $('.provider').show();
        }
    });
}

$('.view-all-providers').click(function() {
    if(!results_visible) {
        $('.provider-results').show();
    }
    $('.provider').show();
    $('#specialty-search').val('');
    $('#doctor-search').val('');
});

// var people_json = JSON.parse( $('#people-json').text() );
// console.log(people_json);
// fuzzysearch('mat', people_json);
$('.search').click(function(){
    var options = {
        type: 'search'
    };
    openOverlay(options);
});


var timer;
var windowHeight = $(window).height();
var triggerHeight = $('.banner').outerHeight() + 200;
var stickyNavVisible = false;

$(window).scroll(function() {
	if(timer) {
		window.clearTimeout(timer);
	}

	timer = window.setTimeout(function() {

		// this variable changes between callbacks, so we can't cache it
		var y = $(window).scrollTop();

	    if((y > triggerHeight) && (!stickyNavVisible)) {
            stickyNavVisible = true;
	        //console.log('show');
            $('.sticky-nav').addClass('visible');
            return true;
	    }
        //console.log(y, triggerHeight);
        if ((y < triggerHeight) && (stickyNavVisible)) {
            stickyNavVisible = false;
            //console.log('hide');
            $('.sticky-nav').removeClass('visible');
            return true;
        }


	}, 100);
});

$('.side-bar-toggle').click(function() {
    $(this).parent().toggleClass('open');
});

var alphabet = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
];

global.initMap = function initMap() {
    // Display the map
    if(document.getElementById("locations") == null) {
        return false;
    }
    var locations = JSON.parse( document.getElementById("locations").innerHTML );
    var map = new google.maps.Map(document.getElementById('map'));    //create empty LatLngBounds object
    var bounds = new google.maps.LatLngBounds();
    var infowindow = new google.maps.InfoWindow();
    var i = 0;
    for (i = 0; i < locations.length; i++) {

        if(locations[i].orthostat) {
            var iconImg = '/img/pins/' + alphabet[i] + '-ortho.svg';
        } else {
            var iconImg = '/img/pins/' + alphabet[i] + '.svg';
        }

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i].lat, locations[i].lng),
            icon: new google.maps.MarkerImage(iconImg,null, null, null, new google.maps.Size(30,42)),
            map: map,
            animation: google.maps.Animation.DROP
        });

        //extend the bounds to include each marker's position
        bounds.extend(marker.position);

        google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                //console.log(locations[i]);
                if(locations[i].addressOverride) {
                    var addressString = locations[i].addressOverride;
                } else {
                    var addressString = locations[i].address + ' <br> ' + locations[i].address2;
                }

                var content = ' \
                    <h4 class="mt-0">'+ locations[i].title +'</h4> \
                    <div>' + addressString +'</div> \
                    <div class="mt-2">' + locations[i].phone + '</div> \
                ';

                // console.log(locations[i]);
                
                content = content + '<a href="https://www.google.com/maps/dir/?api=1&destination='+ locations[i].addressUrl +'" class="btn btn-map btn-solid" target="_blank">Get directions</a>'

                // Refactor based on lat, long
                // content = content + '<a href="https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination='+ encodeURI(locations[i].lat) + ',' + encodeURI(locations[i].lng) + '" class="btn btn-map btn-solid" target="_blank">Get directions</a>'
                
                if(locations[i].orthostat) {
                    content = '<div class="orthostat">' + content + '</div>';
                }
                infowindow.setContent(content);
                infowindow.open(map, marker);
            }
        })(marker, i));
    }

    //now fit the map to the newly inclusive bounds
    map.fitBounds(bounds);

    //(optional) restore the zoom level after the map is done scaling
    var listener = google.maps.event.addListener(map, "idle", function () {
        map.setZoom(9);
        google.maps.event.removeListener(listener);
    });
}

$(function () {
    //console.log('fix images');
    objectFitImages();
    // pageAccelerator({
    //     beforeLoading: function() {
    //         console.log('preload');
    //     },
    //     afterLoading: function() {
    //         console.log('done');
    //         initMap();
    //     }
    // });
 });
